.errorBoundary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  align-items: center;
}

.logo {
  height: 25vh;
  margin-bottom: 4vh;
}

.button {
  float: right;
  margin-top: 4vh;
}
